import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // "provider" gate also admits respite users (compartmentalized inside the provider shell).
  const allowed =
    !role ||
    user.role === role ||
    (role === "provider" && user.role === "respite");
  if (!allowed) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/provider"} replace />;
  }
  return children;
}
